if (!customElements.get('country-selector')) {
  customElements.define('country-selector', class CountrySelector extends HTMLElement {
    constructor() {
      super();
      this.handleToggleClick = this.handleToggleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleFocusOut = this.handleFocusOut.bind(this);
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
    }

    connectedCallback() {
      this.toggle = this.querySelector('.CountrySelector__Toggle');
      this.panel = this.querySelector('.CountrySelector__Panel');
      this.list = this.querySelector('.CountrySelector__List');
      if (!this.toggle || !this.panel) return;

      this.toggle.addEventListener('click', this.handleToggleClick);
      this.addEventListener('keydown', this.handleKeydown);
      this.addEventListener('focusout', this.handleFocusOut);
      document.addEventListener('click', this.handleDocumentClick);
    }

    disconnectedCallback() {
      this.toggle?.removeEventListener('click', this.handleToggleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      this.removeEventListener('focusout', this.handleFocusOut);
      document.removeEventListener('click', this.handleDocumentClick);
    }

    get isOpen() {
      return this.toggle.getAttribute('aria-expanded') === 'true';
    }

    open() {
      this.toggle.setAttribute('aria-expanded', 'true');
      this.panel.hidden = false;
      this.scrollToCurrent();
    }

    close({ restoreFocus = false } = {}) {
      if (!this.isOpen) return;

      this.toggle.setAttribute('aria-expanded', 'false');
      this.panel.hidden = true;
      if (restoreFocus) this.toggle.focus();
    }

    scrollToCurrent() {
      const current = this.list?.querySelector('[aria-current="true"]');
      if (!current) return;

      this.list.scrollTop = current.offsetTop - this.list.offsetTop;
    }

    handleToggleClick() {
      if (this.isOpen) {
        this.close();
        return;
      }

      this.open();
    }

    handleKeydown(event) {
      if (event.key !== 'Escape' || !this.isOpen) return;

      event.stopPropagation();
      this.close({ restoreFocus: true });
    }

    handleFocusOut(event) {
      if (!event.relatedTarget || this.contains(event.relatedTarget)) return;

      this.close();
    }

    handleDocumentClick(event) {
      if (this.contains(event.target)) return;

      this.close();
    }
  });
}
